export default __webpack_public_path__ + "assets/late-clock-red.547a.svg";